import { render, staticRenderFns } from "./TestLayout.vue?vue&type=template&id=5d880f02&"
import script from "./TestLayout.vue?vue&type=script&lang=ts&"
export * from "./TestLayout.vue?vue&type=script&lang=ts&"
import style0 from "./TestLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports